import { Component, OnInit } from '@angular/core';
import { SidebarService } from 'src/app/core/services/sidebar.service';
import { AuthService } from 'src/app/core/services/auth.service'; // <--- Importe o AuthService
import { SidebarGroup } from 'src/app/shared/models/sidebarGroup';
import { TenantService } from 'src/app/core/services/tenant.service';

@Component({
  selector: 'app-admin-panel',
  templateUrl: './admin-panel.component.html',
  standalone: false,
})
export class AdminPanelComponent implements OnInit {
  tenantLogo: string = 'assets/img/connect-sea/favicon-connectsea.png';

  private setTenantLogo(): void {
    const tenantId = this.tenantService.tenantId?.toLowerCase() ?? '';
    if (tenantId.startsWith('greatocean')) {
      this.tenantLogo =
        'assets/img/greatocean/greatocean-square-logo-white.png';
    } else if (tenantId.startsWith('lachmann')) {
      this.tenantLogo = 'assets/img/lachmann/lachmann-logo-colorida.png';
    } else if (tenantId.startsWith('cosco')) {
      this.tenantLogo = 'assets/img/cosco/cosco-logo-branca.png';
    } else {
      this.tenantLogo = 'assets/img/connect-sea/favicon-connectsea.png';
    }
  }
  adminMenu: SidebarGroup[] = [];

  constructor(
    private sidebarService: SidebarService,
    private authService: AuthService, // <--- Injete aqui
    private tenantService: TenantService,
  ) {
    this.setTenantLogo();
  }

  ngOnInit() {
    // 1. Garante sidebar aberta
    setTimeout(() => {
      this.sidebarService.setCollapsed(false);
    }, 50);

    // 2. Monta o menu dinamicamente
    this.buildMenu();
  }

  buildMenu() {
    // Gating baseado em grupos: Admin (privilégio ilimitado) e Managed (admin de tenant).
    const isAdminGroup = this.authService.groupMatch(['Admin']);
    const isManagedGroup = this.authService.groupMatch(['Managed']);
    // Acesso administrativo geral: pertence ao grupo Admin ou Managed.
    const canManage = isAdminGroup || isManagedGroup;
    const isConnectSeaAdminTenant =
      this.tenantService.isConnectSeaAdminTenant();

    // Itens padrão - visíveis conforme permissões
    const menuItems: any[] = [];

    // Itens restritos ao tenant administrador da ConnectSea e exclusivos do grupo Admin.
    if (isConnectSeaAdminTenant && isAdminGroup) {
      menuItems.push({
        name: 'Endpoint Permissions',
        route: '/admin/endpoint-permissions',
        icon: 'pi pi-shield',
      });
      menuItems.push({
        name: 'Removed Endpoints',
        route: '/admin/removed-endpoints',
        icon: 'pi pi-trash',
      });
      menuItems.push({
        name: 'Tenant Management',
        route: '/admin/tenant',
        icon: 'pi pi-database',
      });
      menuItems.push({
        name: 'Countries',
        route: '/admin/countries',
        icon: 'pi pi-flag',
      });
    }

    // Itens disponíveis em todos os tenants para os grupos Admin ou Managed.
    if (canManage) {
      menuItems.push({
        name: 'User Management',
        route: '/admin/users',
        icon: 'pi pi-users',
      });
      menuItems.push({
        name: 'Permission Groups',
        route: '/admin/groups',
        icon: 'pi pi-objects-column',
      });
      menuItems.push({
        name: 'Currencies',
        route: '/admin/currencies',
        icon: 'pi pi-dollar',
      });
      menuItems.push({
        name: 'Integrations',
        route: '/admin/integrations',
        icon: 'pi pi-sitemap',
      });
      menuItems.push({
        name: 'Audit Logs',
        route: '/admin/audits',
        icon: 'pi pi-history',
      });
    }

    // 3. Atribui ao objeto final que vai pro HTML
    this.adminMenu = [
      {
        name: '',
        isExpanded: true,
        isFixed: true,
        items: menuItems,
      },
    ];
  }
}
